/**
 * Created by swandelow on 09/05/17.
 */
angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:oid/fleet", {
        template: '<fleet-component></fleet-component>',
        title: 'fleet.TITLE',
        sidebar: 'fleet'
    }).when("/company/:companyOid/fleet/:oid", { // falta migrar esta pantalla a componentes
        templateUrl: 'assets/fleet/edit.html',
        controller: 'CarController',
        title: 'fleet.TITLE',
        sidebar: 'fleet'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/fleet/fleet.route.js
// module id = 894
// module chunks = 3